// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1He0L","dragIcon":"SortableItem_dragIcon__2A7QV","disabled":"SortableItem_disabled__3dzuW"};